import { useState } from 'react'
import { Outlet } from 'react-router-dom'
import Sidebar from './sidebar/Sidebar'
import BroadcastDeviceDialog from './BroadcastDeviceDialog'
import AnnouncementDialog from './AnnouncementDialog'
import { Button } from '@/components/ui/button'
import { Menu } from 'lucide-react'
import { cn } from '@/lib/utils'
import UserAvatarMenu from './UserMenu/UserAvatarMenu'
import FastNavigationBar from './FastNavigationBar'

export default function Layout() {
  const [sidebarOpen, setSidebarOpen] = useState(false)

  return (
    <div className="flex h-screen w-screen overflow-hidden">
      {/* 移動端覆蓋層 */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-40 md:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Sidebar */}
      <div
        className={cn(
          'md:relative md:translate-x-0 md:z-auto overflow-y-auto',
          'fixed left-0 top-0 h-full z-50 transition-transform duration-300 ease-in-out',
          sidebarOpen ? 'translate-x-0' : '-translate-x-full',
        )}
      >
        <Sidebar onClose={() => setSidebarOpen(false)} />
      </div>

      <div className="flex-1 relative bg-gradient-to-br from-gray-50 to-gray-100 overflow-hidden">
        <FastNavigationBar variant="desktop" />
        {/* Desktop top-right user menu */}
        <div className="hidden md:block absolute right-4 top-4 z-30">
          <UserAvatarMenu />
        </div>
        {/* 移動端頂部導航欄 */}
        <div className="md:hidden relative z-30 bg-white/80 backdrop-blur-sm border-b border-gray-200/50">
          <div className="flex items-center justify-between px-4 py-3">
            <Button variant="ghost" size="sm" onClick={() => setSidebarOpen(true)} className="p-2">
              <Menu className="h-5 w-5" />
            </Button>
            <div className="text-sm font-medium text-gray-700">Magnetar Admin</div>
            <UserAvatarMenu />
          </div>
        </div>

        {/* 裝飾性背景元素 */}
        <div className="absolute top-0 left-0 w-full h-full">
          <div className="absolute top-0 right-0 w-1/3 h-1/3 bg-gradient-to-br from-blue-100/30 to-cyan-100/30 rounded-full filter blur-3xl transform translate-x-1/2 -translate-y-1/2" />
          <div className="absolute bottom-0 left-0 w-1/2 h-1/2 bg-gradient-to-tr from-teal-100/30 to-blue-100/30 rounded-full filter blur-3xl transform -translate-x-1/3 translate-y-1/3" />
        </div>

        <div className="relative h-full overflow-y-auto">
          <div className="container mx-auto px-4 sm:px-6 md:px-8 py-6 md:py-20 space-y-6 md:space-y-8">
            <Outlet />
          </div>
        </div>
      </div>
      <BroadcastDeviceDialog />
      <AnnouncementDialog />

      {/* 版本號（右下角，來自 package.json） */}
      <div className="fixed bottom-1.5 right-2.5 z-50 text-[10px] leading-none text-gray-400/70 select-none pointer-events-none">
        v{__APP_VERSION__}
      </div>
    </div>
  )
}
